import { GlobalState } from '@leverege/ui-redux';
import { DateTimeRangePicker } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import TimelineDataset from "./TimelineDataset.js";
import RsrcFilterModel from "../../../filter/RsrcFilterModel.js";
import TimelineUtil from "../TimelineUtil.js";
import ResourceCache from "./ResourceCache.js";
export default class ResourceTimelineDataSet extends TimelineDataset {
  #data = [];
  #delegate;
  #path;
  #range;
  #cache;
  constructor(opts) {
    super(opts);
    const {
      path,
      range,
      rsrcDelegate
    } = opts;
    this.#range = range;
    this.#delegate = rsrcDelegate;
    this.#path = path;
    this.#cache = new ResourceCache({
      delegate: rsrcDelegate
    });
    this.offset = 0;
    this.mayHaveMore = true;
  }
  get filter() {
    let filter = RsrcFilterModel.create();
    const range = DateTimeRangePicker.getRange(this.#range);
    filter = RsrcFilterModel.setFilter(filter, 'createdAt', range);
    filter = RsrcFilterModel.setFilter(filter, 'path', this.#path);
    filter = RsrcFilterModel.setFilter(filter, 'expression', 'type LIKE \'image%\'');
    return RsrcFilterModel.toRsrcFilter(filter);
  }
  getFilter(dateTime, precision) {
    let filter = RsrcFilterModel.create();
    if (precision) {
      filter = RsrcFilterModel.setFilter(filter, 'createdAt', {
        start: dateTime.minus(precision).toUTC().toISO(),
        end: dateTime.plus(precision).toUTC().toISO()
      });
    }
    filter = RsrcFilterModel.setFilter(filter, 'path', this.#path);
    filter = RsrcFilterModel.setFilter(filter, 'expression', 'type LIKE \'image%\'');
    return RsrcFilterModel.toRsrcFilter(filter);
  }
  async getNearestDatum(scrubTime, precision) {
    if (this.#range) {
      const dateTime = TimelineUtil.coerceDateTime(scrubTime);
      const cached = await this.#cache.get(dateTime);
      if (cached) {
        return cached;
      }
      const data = await GlobalState.dispatch(this.#delegate.search({
        filter: this.getFilter(dateTime, precision),
        limit: 1,
        order: {
          type: 'ExpressionField.base64',
          value: Buffer.from(JSON.stringify({
            type: 'ExpressionField.expression',
            value: `ABS( EXTRACT( EPOCH FROM createdAt - CAST( '${dateTime.toUTC().toSQL()}', 'TIMESTAMP' ) ) ) ASC`
          })).toString('base64')
        },
        queryName: `rsrc.timeline.${this.#path}`,
        returnCount: false,
        childrenOnly: true
      }));
      if (data.items[0]) {
        const objRef = this.#delegate.item(data.items[0].path).toObjectRef(data.items[0]);
        this.#cache.set(dateTime, objRef);
        await loadImage(Attributes.get('rsrc.url', objRef));
        return objRef;
      }
      return null;
    }
    return null;
  }
}
async function loadImage(url) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      resolve();
    };
    img.onerror = () => {
      resolve();
    };
    img.src = url;
  });
}